import { DateTime } from "luxon";
import { days, months } from "../api/models/consts";

export const formatDate = (date: Date, formatString: string) => {
    const dt = new Date(date);
    if (dt.getDate()) {
        return formatString
            .replace("dd", padZero(dt.getDate()))
            .replace("DDDD", days[dt.getDay()])
            .replace("DD", dt.getDate().toString())
            .replace("MMMM", months[dt.getMonth()].toLowerCase())
            .replace("MMM", padZero(dt.getMonth() + 1))
            .replace("MM", (dt.getMonth() + 1).toString())            
            .replace("yyyy", String(dt.getFullYear()))
            .replace("yy", String(dt.getFullYear()).substring(2))
            .replace("HH", padZero(dt.getHours()))
            .replace("mm", padZero(dt.getMinutes()))
            .replace("ss", padZero(dt.getSeconds()));
    } else {
        return "";
    }
};

const padZero = (n: number): string => (n < 10 ? `0${n}` : String(n));

export const timeDiff = (curr: Date, prev: Date) => {
    const diff = DateTime.fromJSDate(curr).diff(DateTime.fromJSDate(prev), ['hours', 'minutes', 'seconds']);
    const seconds = diff.seconds;
    const minutes = diff.minutes;
    const hours = diff.hours;
    return `${hours > 0 ? `${hours}:` : ''}${minutes.toString().substring(0, 2)}:${padZero(seconds).substring(0, 2)}`;
}